// @flow

import React from 'react';
import { connect } from 'react-redux';
import { TileSelect, Tile } from '../tileSelect';
import OptionPrice from '../optionPrice';
import { getDurations } from '../../../../store/configuration/actives';
import {
  getActiveDurationId,
  selectDuration,
} from '../../../../store/configuration';
import { getPerMonthAbbrv } from '../../../../store/configuratorSettings/selectors';
import type { Duration } from '../../../../types/pdb';

type OwnProps = {|
  blocksPerRow: number,
  variant?: ?string,
  pdbId?: ?string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  durations: Array<Duration>,
  activeDuration: ?number,
  postfix: string,
|};

type DispatchProps = {|
  setDuration: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const Durations = ({
  durations,
  activeDuration,
  setDuration,
  blocksPerRow,
  variant,
  postfix,
}: Props) => (
  <TileSelect>
    {durations.map(({
      id, name, price, most_chosen,
    }) => (
      <Tile
        key={id}
        active={activeDuration === id}
        onClick={() => setDuration(id)}
        blocksPerRow={blocksPerRow}
        blockCount={durations.length}
        mostChosen={most_chosen}
        variant={variant}
      >
        <OptionPrice
          title={name}
          price={parseInt(price, 10)}
          active={activeDuration === id}
          postfix={postfix}
        />
      </Tile>
    ))}
  </TileSelect>
);

Durations.defaultProps = {
  pdbId: null,
  variant: null,
};

const mapStateToProps = (state: any, { pdbId }: OwnProps): StateProps => ({
  durations: getDurations(state, pdbId),
  activeDuration: getActiveDurationId(state, pdbId),
  postfix: getPerMonthAbbrv(state),
});

const mapDispatchToProps = (dispatch: Function, { pdbId }: OwnProps): DispatchProps => ({
  setDuration: (id: number) => dispatch(selectDuration(id, pdbId)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Durations);
